import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-blue-900 to-purple-900 text-white">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-4xl font-bold mb-8">Ready to Get Started?</h2>
        <p className="text-xl text-blue-100 mb-12">
          Transform your recovery process with AI-powered support
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button className="text-lg px-8 py-6 bg-white text-gray-900 hover:bg-gray-100 rounded-full">
            Schedule Demo <ArrowRight className="ml-2" />
          </Button>
          <Button className="text-lg px-8 py-6 bg-transparent border-2 border-white hover:bg-white/10 text-white rounded-full">
            Contact Sales
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;